// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminLlmManagement.css — Dark Data-Dashboard Theme */

/* ===== Alert ===== */
.admin-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: var(--admin-radius-md, 8px);
  margin-bottom: 20px;
}

.admin-alert--warning {
  background: var(--admin-warning-bg);
  border: 1px solid rgba(251, 146, 60, 0.2);
}

.admin-alert--info {
  background: rgba(96, 165, 250, 0.08);
  border: 1px solid rgba(96, 165, 250, 0.2);
}

.admin-alert__icon {
  font-size: 18px;
  flex-shrink: 0;
}

.admin-alert__content {
  flex: 1 1;
}

.admin-alert__title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 2px;
  color: var(--admin-warning);
}

.admin-alert__text {
  font-size: 12px;
  color: var(--admin-text-secondary);
}

.admin-alert__close {
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  padding: 4px;
  font-size: 16px;
}

.admin-alert__close:hover {
  opacity: 1;
}

/* ===== Provider Cards Grid ===== */
.admin-provider-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.admin-provider-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-lg, 12px);
  padding: 20px;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}

.admin-provider-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-color: var(--admin-text-dim);
}

.admin-provider-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}

.admin-provider-card--openai::before {
  background: var(--openai);
}

.admin-provider-card--anthropic::before {
  background: var(--anthropic);
}

.admin-provider-card--google::before {
  background: var(--google);
}

.admin-provider-card--lg::before {
  background: var(--lg);
}

.admin-provider-card--custom::before {
  background: var(--admin-text-muted);
}

.admin-provider-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.admin-provider-card__info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-provider-card__logo {
  width: 44px;
  height: 44px;
  border-radius: var(--admin-radius-md, 8px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 18px;
}

.admin-provider-card__name {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2px;
  color: var(--admin-text-primary);
}

.admin-provider-card__type {
  font-size: 11px;
  color: var(--admin-text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
}

.admin-provider-card__status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-provider-card__stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--admin-border);
  border-bottom: 1px solid var(--admin-border);
  margin-bottom: 16px;
}

.admin-provider-stat {
  text-align: center;
}

.admin-provider-stat__value {
  font-size: 18px;
  font-weight: 700;
  color: var(--admin-text-primary);
}

.admin-provider-stat__label {
  font-size: 10px;
  color: var(--admin-text-muted);
  margin-top: 2px;
}

.admin-provider-card__actions {
  display: flex;
  gap: 8px;
}

.admin-provider-card__actions .admin-btn {
  flex: 1 1;
  justify-content: center;
}

/* ===== Add Card ===== */
.admin-add-card {
  background: var(--admin-surface);
  border: 2px dashed var(--admin-border);
  border-radius: var(--admin-radius-lg, 12px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 200px;
}

.admin-add-card:hover {
  border-color: #a78bfa;
  background: rgba(167, 139, 250, 0.05);
}

.admin-add-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  background: var(--admin-surface-hover);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: var(--admin-text-muted);
  font-size: 24px;
}

.admin-add-card:hover .admin-add-card__icon {
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa;
}

.admin-add-card__text {
  font-size: 14px;
  font-weight: 500;
  color: var(--admin-text-secondary);
}

.admin-add-card:hover .admin-add-card__text {
  color: #a78bfa;
}

/* ===== Section ===== */
.admin-section {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-lg, 12px);
  overflow: hidden;
  margin-bottom: 24px;
}

.admin-section:last-child {
  margin-bottom: 0;
}

.admin-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface-hover);
}

.admin-section__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-section__actions {
  display: flex;
  gap: 8px;
}

/* ===== Model Filter Bar ===== */
.admin-model-filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
  flex-wrap: wrap;
}

.admin-model-filter-bar__label {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
}

.admin-model-filter-bar__select {
  padding: 6px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  cursor: pointer;
}

.admin-model-filter-bar__select:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-model-filter-bar__search {
  padding: 6px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  min-width: 180px;
  flex: 1 1;
  max-width: 260px;
}

.admin-model-filter-bar__search::placeholder {
  color: var(--admin-text-dim);
}

.admin-model-filter-bar__search:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-model-filter-bar__count {
  margin-left: auto;
  font-size: 11px;
  font-weight: 500;
  color: var(--admin-text-muted);
  background: var(--admin-surface-hover);
  padding: 3px 10px;
  border-radius: 9999px;
}

/* ===== Model List ===== */
.admin-model-list {
  padding: 16px 20px;
}

.admin-model-list__empty {
  text-align: center;
  padding: 48px 20px;
  color: var(--admin-text-muted);
}

.admin-model-list__empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.admin-model-list__empty-text {
  font-size: 14px;
  margin-bottom: 16px;
}

.admin-model-group {
  margin-bottom: 24px;
}

.admin-model-group:last-child {
  margin-bottom: 0;
}

.admin-model-group__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: var(--admin-surface-hover);
  border-radius: var(--admin-radius-md, 8px);
}

.admin-model-group__logo {
  width: 28px;
  height: 28px;
  border-radius: var(--admin-radius-sm, 4px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 12px;
}

.admin-model-group__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-model-group__count {
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-model-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  margin-bottom: 8px;
  transition: all 0.2s;
  border-bottom: 1px solid var(--admin-border-light);
}

.admin-model-item:last-child {
  margin-bottom: 0;
}

.admin-model-item:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
}

.admin-model-item--disabled {
  opacity: 0.5;
}

.admin-model-item__info {
  flex: 1 1;
  min-width: 0;
}

.admin-model-item__name {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-primary);
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.admin-model-item__id {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-family: monospace;
  background: var(--admin-surface-hover);
  padding: 2px 6px;
  border-radius: var(--admin-radius-sm, 4px);
}

.admin-model-item__desc {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-model-item__meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: 16px;
}

.admin-model-item__pricing {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: right;
}

.admin-model-item__price {
  font-size: 12px;
  color: var(--admin-text-secondary);
}

.admin-model-item__price span {
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-model-item__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ===== Capability Badges ===== */
.admin-cap-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.admin-cap-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 7px;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-cap-badge--text {
  background: rgba(96, 165, 250, 0.12);
  color: #60a5fa;
}

.admin-cap-badge--image {
  background: rgba(244, 114, 182, 0.12);
  color: #f472b6;
}

.admin-cap-badge--vision {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-cap-badge--audio {
  background: rgba(167, 139, 250, 0.12);
  color: #a78bfa;
}

.admin-cap-badge--embed {
  background: rgba(251, 191, 36, 0.12);
  color: #fbbf24;
}

/* ===== Model Pagination ===== */
.admin-model-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-surface-hover);
}

.admin-model-pagination__info {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-model-pagination__right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-model-pagination__size {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-model-pagination__size-label {
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-model-pagination__size-select {
  padding: 3px 8px;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-sm, 4px);
  font-size: 11px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  cursor: pointer;
}

.admin-model-pagination__size-select:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-model-pagination__nav {
  display: flex;
  align-items: center;
  gap: 2px;
}

.admin-model-pg-btn {
  width: 28px;
  height: 28px;
  border: 1px solid var(--admin-border);
  background: var(--admin-bg);
  border-radius: var(--admin-radius-sm, 4px);
  font-size: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.15s;
}

.admin-model-pg-btn:hover:not(:disabled) {
  border-color: #a78bfa;
  color: #a78bfa;
  background: rgba(167, 139, 250, 0.08);
}

.admin-model-pg-btn--active {
  background: var(--admin-border);
  color: var(--admin-text-primary);
  border-color: var(--admin-border);
}

.admin-model-pg-btn--active:hover {
  background: var(--admin-text-dim);
  border-color: var(--admin-text-dim);
  color: var(--admin-text-primary);
}

.admin-model-pg-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

/* ===== Radio Cards ===== */
.admin-radio-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.admin-radio-card {
  position: relative;
  padding: 16px;
  background: var(--admin-bg);
  border: 2px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-radio-card:hover {
  border-color: var(--admin-text-dim);
}

.admin-radio-card.selected {
  border-color: #a78bfa;
  background: rgba(167, 139, 250, 0.05);
}

.admin-radio-card input {
  position: absolute;
  opacity: 0;
}

.admin-radio-card__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--admin-radius-md, 8px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 20px;
}

.admin-radio-card__icon--api {
  background: rgba(96, 165, 250, 0.12);
}

.admin-radio-card__icon--gpu {
  background: var(--admin-success-bg);
}

.admin-radio-card__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-primary);
  margin-bottom: 4px;
}

.admin-radio-card__desc {
  font-size: 12px;
  color: var(--admin-text-muted);
}

/* ===== Color Options ===== */
.admin-color-options {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.admin-color-option {
  width: 32px;
  height: 32px;
  border-radius: var(--admin-radius-md, 8px);
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}

.admin-color-option:hover {
  transform: scale(1.1);
}

.admin-color-option.selected {
  border-color: #a78bfa;
  box-shadow: 0 0 0 2px var(--admin-bg);
}

/* ===== Capability Checkbox Grid ===== */
.admin-cap-check-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.admin-cap-check-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 2px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-cap-check-item:hover {
  border-color: var(--admin-text-dim);
}

.admin-cap-check-item.checked {
  border-color: #a78bfa;
  background: rgba(167, 139, 250, 0.1);
}

.admin-cap-check-item input[type='checkbox'] {
  width: 16px;
  height: 16px;
  accent-color: #a78bfa;
  cursor: pointer;
  flex-shrink: 0;
}

.admin-cap-check-item__icon {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.admin-cap-check-item__label {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-primary);
}

/* ===== Provider Setting Modal Tabs ===== */
.admin-prov-tab {
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.admin-prov-tab:hover {
  color: var(--admin-text-primary);
  background: var(--admin-surface-hover);
}

.admin-prov-tab--active {
  background: var(--admin-border);
  color: var(--admin-text-primary);
  border-bottom-color: #a78bfa;
}

/* ===== API Key Status Card ===== */
.admin-apikey-status-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  margin-bottom: 16px;
}

.admin-apikey-status-card__label {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}

.admin-apikey-status-card__key {
  font-family: monospace;
  font-size: 15px;
  font-weight: 600;
  color: var(--admin-text-primary);
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.admin-apikey-status-card__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--admin-text-muted);
  flex-wrap: wrap;
}

.admin-apikey-status-card__sep {
  color: var(--admin-text-dim);
}

.admin-apikey-status-badge {
  padding: 3px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
}

.admin-apikey-status-badge--active {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-apikey-status-badge--expiring {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-apikey-status-badge--expired {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

/* ===== Expiry Section ===== */
.admin-apikey-expiry-section {
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  margin-bottom: 16px;
  overflow: hidden;
}

.admin-apikey-expiry-header {
  padding: 12px 16px;
  background: var(--admin-surface-hover);
  border-bottom: 1px solid var(--admin-border);
}

.admin-apikey-expiry-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-apikey-expiry-body {
  padding: 16px;
}

.admin-apikey-expiry-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.admin-apikey-expiry-remaining {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 9999px;
  white-space: nowrap;
}

/* ===== Verify Box ===== */
.admin-apikey-verify-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--admin-radius-md, 8px);
  margin-top: 12px;
}

.admin-apikey-verify-box--pending {
  background: rgba(96, 165, 250, 0.08);
  border: 1px solid rgba(96, 165, 250, 0.2);
}

.admin-apikey-verify-box--success {
  background: var(--admin-success-bg);
  border: 1px solid rgba(74, 222, 128, 0.2);
}

.admin-apikey-verify-box--error {
  background: var(--admin-error-bg);
  border: 1px solid rgba(248, 113, 113, 0.2);
}

.admin-apikey-verify-box__icon {
  font-size: 24px;
  flex-shrink: 0;
}

.admin-apikey-verify-box__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-apikey-verify-box__desc {
  font-size: 12px;
  color: var(--admin-text-secondary);
  margin-top: 2px;
}

/* ===== Key Change Section ===== */
.admin-apikey-change-section {
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  overflow: hidden;
}

.admin-apikey-change-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--admin-surface-hover);
  cursor: pointer;
  transition: background 0.15s;
}

.admin-apikey-change-header:hover {
  background: var(--admin-border);
}

.admin-apikey-change-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-apikey-change-chevron {
  color: var(--admin-text-muted);
  transition: transform 0.2s;
}

.admin-apikey-change-chevron--open {
  transform: rotate(180deg);
}

.admin-apikey-change-body {
  padding: 16px;
  border-top: 1px solid var(--admin-border);
}

/* ===== History List ===== */
.admin-apikey-history-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.admin-apikey-history-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--admin-border-light);
  position: relative;
}

.admin-apikey-history-item:last-child {
  border-bottom: none;
}

.admin-apikey-history-item__icon {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.admin-apikey-history-item__icon--change {
  background: rgba(96, 165, 250, 0.12);
}

.admin-apikey-history-item__icon--verify {
  background: var(--admin-success-bg);
}

.admin-apikey-history-item__icon--expire {
  background: rgba(251, 191, 36, 0.12);
}

.admin-apikey-history-item__icon--create {
  background: rgba(167, 139, 250, 0.12);
}

.admin-apikey-history-item__icon--delete {
  background: var(--admin-error-bg);
}

.admin-apikey-history-item__content {
  flex: 1 1;
  min-width: 0;
}

.admin-apikey-history-item__title {
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-primary);
  margin-bottom: 2px;
}

.admin-apikey-history-item__title strong {
  font-weight: 600;
}

.admin-apikey-history-item__detail {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-family: monospace;
}

.admin-apikey-history-item__time {
  font-size: 11px;
  color: var(--admin-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

/* ===== Context Window Column ===== */
.admin-model-item__context {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 56px;
}

.admin-model-item__context-label {
  font-size: 10px;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-model-item__context-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
  font-family: monospace;
}

/* ===== Capability Badge (short label variant) ===== */
.admin-llm__cap-badge {
  min-width: 22px;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

/* ===== Connection Test Result Modal ===== */
.admin-llm__test-result {
  border-radius: var(--admin-radius-md, 8px);
  padding: 16px;
  margin-bottom: 12px;
}

.admin-llm__test-result--success {
  background: var(--admin-success-bg);
  border: 1px solid rgba(74, 222, 128, 0.2);
}

.admin-llm__test-result--error {
  background: var(--admin-error-bg);
  border: 1px solid rgba(248, 113, 113, 0.2);
}

.admin-llm__test-result-status {
  font-size: 14px;
  font-weight: 700;
  color: var(--admin-text-primary);
  margin-bottom: 12px;
}

.admin-llm__test-result--success .admin-llm__test-result-status {
  color: var(--admin-success);
}

.admin-llm__test-result--error .admin-llm__test-result-status {
  color: var(--admin-error);
}

.admin-llm__test-result-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.admin-llm__test-result-row:last-child {
  margin-bottom: 0;
}

.admin-llm__test-result-key {
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-secondary);
  min-width: 80px;
  flex-shrink: 0;
}

.admin-llm__test-result-val {
  font-size: 12px;
  color: var(--admin-text-primary);
}

.admin-llm__test-result-val--mono {
  font-family: monospace;
  background: var(--admin-surface-hover);
  padding: 1px 6px;
  border-radius: var(--admin-radius-sm, 4px);
}

.admin-llm__test-result-val--error {
  color: var(--admin-error);
  word-break: break-all;
}

/* ===== Sample Response Block ===== */
.admin-llm__test-sample {
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md, 8px);
  overflow: hidden;
}

.admin-llm__test-sample-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 8px 12px;
  background: var(--admin-surface-hover);
  border-bottom: 1px solid var(--admin-border);
}

.admin-llm__test-sample-body {
  margin: 0;
  padding: 12px;
  font-size: 12px;
  font-family: monospace;
  color: var(--admin-text-secondary);
  background: var(--admin-bg);
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 200px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/css/AdminLlmManagement.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,sCAAsC;EACtC,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;EACtC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* AdminLlmManagement.css — Dark Data-Dashboard Theme */\n\n/* ===== Alert ===== */\n.admin-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: var(--admin-radius-md, 8px);\n  margin-bottom: 20px;\n}\n\n.admin-alert--warning {\n  background: var(--admin-warning-bg);\n  border: 1px solid rgba(251, 146, 60, 0.2);\n}\n\n.admin-alert--info {\n  background: rgba(96, 165, 250, 0.08);\n  border: 1px solid rgba(96, 165, 250, 0.2);\n}\n\n.admin-alert__icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.admin-alert__content {\n  flex: 1;\n}\n\n.admin-alert__title {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  color: var(--admin-warning);\n}\n\n.admin-alert__text {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n.admin-alert__close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.6;\n  padding: 4px;\n  font-size: 16px;\n}\n\n.admin-alert__close:hover {\n  opacity: 1;\n}\n\n/* ===== Provider Cards Grid ===== */\n.admin-provider-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.admin-provider-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-lg, 12px);\n  padding: 20px;\n  transition: all 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.admin-provider-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  border-color: var(--admin-text-dim);\n}\n\n.admin-provider-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n}\n\n.admin-provider-card--openai::before {\n  background: var(--openai);\n}\n\n.admin-provider-card--anthropic::before {\n  background: var(--anthropic);\n}\n\n.admin-provider-card--google::before {\n  background: var(--google);\n}\n\n.admin-provider-card--lg::before {\n  background: var(--lg);\n}\n\n.admin-provider-card--custom::before {\n  background: var(--admin-text-muted);\n}\n\n.admin-provider-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.admin-provider-card__info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-provider-card__logo {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--admin-radius-md, 8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.admin-provider-card__name {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  color: var(--admin-text-primary);\n}\n\n.admin-provider-card__type {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.admin-provider-card__status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-provider-card__stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid var(--admin-border);\n  border-bottom: 1px solid var(--admin-border);\n  margin-bottom: 16px;\n}\n\n.admin-provider-stat {\n  text-align: center;\n}\n\n.admin-provider-stat__value {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n}\n\n.admin-provider-stat__label {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n}\n\n.admin-provider-card__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.admin-provider-card__actions .admin-btn {\n  flex: 1;\n  justify-content: center;\n}\n\n/* ===== Add Card ===== */\n.admin-add-card {\n  background: var(--admin-surface);\n  border: 2px dashed var(--admin-border);\n  border-radius: var(--admin-radius-lg, 12px);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-height: 200px;\n}\n\n.admin-add-card:hover {\n  border-color: #a78bfa;\n  background: rgba(167, 139, 250, 0.05);\n}\n\n.admin-add-card__icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 9999px;\n  background: var(--admin-surface-hover);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  color: var(--admin-text-muted);\n  font-size: 24px;\n}\n\n.admin-add-card:hover .admin-add-card__icon {\n  background: rgba(167, 139, 250, 0.15);\n  color: #a78bfa;\n}\n\n.admin-add-card__text {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n}\n\n.admin-add-card:hover .admin-add-card__text {\n  color: #a78bfa;\n}\n\n/* ===== Section ===== */\n.admin-section {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-lg, 12px);\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n.admin-section:last-child {\n  margin-bottom: 0;\n}\n\n.admin-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface-hover);\n}\n\n.admin-section__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-section__actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* ===== Model Filter Bar ===== */\n.admin-model-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  flex-wrap: wrap;\n}\n\n.admin-model-filter-bar__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n}\n\n.admin-model-filter-bar__select {\n  padding: 6px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  cursor: pointer;\n}\n\n.admin-model-filter-bar__select:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-model-filter-bar__search {\n  padding: 6px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  min-width: 180px;\n  flex: 1;\n  max-width: 260px;\n}\n\n.admin-model-filter-bar__search::placeholder {\n  color: var(--admin-text-dim);\n}\n\n.admin-model-filter-bar__search:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-model-filter-bar__count {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--admin-text-muted);\n  background: var(--admin-surface-hover);\n  padding: 3px 10px;\n  border-radius: 9999px;\n}\n\n/* ===== Model List ===== */\n.admin-model-list {\n  padding: 16px 20px;\n}\n\n.admin-model-list__empty {\n  text-align: center;\n  padding: 48px 20px;\n  color: var(--admin-text-muted);\n}\n\n.admin-model-list__empty-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.admin-model-list__empty-text {\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.admin-model-group {\n  margin-bottom: 24px;\n}\n\n.admin-model-group:last-child {\n  margin-bottom: 0;\n}\n\n.admin-model-group__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  background: var(--admin-surface-hover);\n  border-radius: var(--admin-radius-md, 8px);\n}\n\n.admin-model-group__logo {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--admin-radius-sm, 4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.admin-model-group__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-model-group__count {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-model-item {\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  margin-bottom: 8px;\n  transition: all 0.2s;\n  border-bottom: 1px solid var(--admin-border-light);\n}\n\n.admin-model-item:last-child {\n  margin-bottom: 0;\n}\n\n.admin-model-item:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n}\n\n.admin-model-item--disabled {\n  opacity: 0.5;\n}\n\n.admin-model-item__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-model-item__name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  margin-bottom: 2px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.admin-model-item__id {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-family: monospace;\n  background: var(--admin-surface-hover);\n  padding: 2px 6px;\n  border-radius: var(--admin-radius-sm, 4px);\n}\n\n.admin-model-item__desc {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-model-item__meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-right: 16px;\n}\n\n.admin-model-item__pricing {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: right;\n}\n\n.admin-model-item__price {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n.admin-model-item__price span {\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-model-item__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ===== Capability Badges ===== */\n.admin-cap-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.admin-cap-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 1px 7px;\n  border-radius: 9999px;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-cap-badge--text {\n  background: rgba(96, 165, 250, 0.12);\n  color: #60a5fa;\n}\n\n.admin-cap-badge--image {\n  background: rgba(244, 114, 182, 0.12);\n  color: #f472b6;\n}\n\n.admin-cap-badge--vision {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-cap-badge--audio {\n  background: rgba(167, 139, 250, 0.12);\n  color: #a78bfa;\n}\n\n.admin-cap-badge--embed {\n  background: rgba(251, 191, 36, 0.12);\n  color: #fbbf24;\n}\n\n/* ===== Model Pagination ===== */\n.admin-model-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-surface-hover);\n}\n\n.admin-model-pagination__info {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-model-pagination__right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-model-pagination__size {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-model-pagination__size-label {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-model-pagination__size-select {\n  padding: 3px 8px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-sm, 4px);\n  font-size: 11px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  cursor: pointer;\n}\n\n.admin-model-pagination__size-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-model-pagination__nav {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.admin-model-pg-btn {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n  border-radius: var(--admin-radius-sm, 4px);\n  font-size: 11px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.15s;\n}\n\n.admin-model-pg-btn:hover:not(:disabled) {\n  border-color: #a78bfa;\n  color: #a78bfa;\n  background: rgba(167, 139, 250, 0.08);\n}\n\n.admin-model-pg-btn--active {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n  border-color: var(--admin-border);\n}\n\n.admin-model-pg-btn--active:hover {\n  background: var(--admin-text-dim);\n  border-color: var(--admin-text-dim);\n  color: var(--admin-text-primary);\n}\n\n.admin-model-pg-btn:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n/* ===== Radio Cards ===== */\n.admin-radio-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.admin-radio-card {\n  position: relative;\n  padding: 16px;\n  background: var(--admin-bg);\n  border: 2px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-radio-card:hover {\n  border-color: var(--admin-text-dim);\n}\n\n.admin-radio-card.selected {\n  border-color: #a78bfa;\n  background: rgba(167, 139, 250, 0.05);\n}\n\n.admin-radio-card input {\n  position: absolute;\n  opacity: 0;\n}\n\n.admin-radio-card__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--admin-radius-md, 8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  font-size: 20px;\n}\n\n.admin-radio-card__icon--api {\n  background: rgba(96, 165, 250, 0.12);\n}\n\n.admin-radio-card__icon--gpu {\n  background: var(--admin-success-bg);\n}\n\n.admin-radio-card__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  margin-bottom: 4px;\n}\n\n.admin-radio-card__desc {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n/* ===== Color Options ===== */\n.admin-color-options {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.admin-color-option {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--admin-radius-md, 8px);\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.admin-color-option:hover {\n  transform: scale(1.1);\n}\n\n.admin-color-option.selected {\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 2px var(--admin-bg);\n}\n\n/* ===== Capability Checkbox Grid ===== */\n.admin-cap-check-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.admin-cap-check-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 2px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-cap-check-item:hover {\n  border-color: var(--admin-text-dim);\n}\n\n.admin-cap-check-item.checked {\n  border-color: #a78bfa;\n  background: rgba(167, 139, 250, 0.1);\n}\n\n.admin-cap-check-item input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  accent-color: #a78bfa;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.admin-cap-check-item__icon {\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.admin-cap-check-item__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-primary);\n}\n\n/* ===== Provider Setting Modal Tabs ===== */\n.admin-prov-tab {\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.admin-prov-tab:hover {\n  color: var(--admin-text-primary);\n  background: var(--admin-surface-hover);\n}\n\n.admin-prov-tab--active {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n  border-bottom-color: #a78bfa;\n}\n\n/* ===== API Key Status Card ===== */\n.admin-apikey-status-card {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  margin-bottom: 16px;\n}\n\n.admin-apikey-status-card__label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 6px;\n}\n\n.admin-apikey-status-card__key {\n  font-family: monospace;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  margin-bottom: 8px;\n  letter-spacing: 0.5px;\n}\n\n.admin-apikey-status-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  flex-wrap: wrap;\n}\n\n.admin-apikey-status-card__sep {\n  color: var(--admin-text-dim);\n}\n\n.admin-apikey-status-badge {\n  padding: 3px 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.admin-apikey-status-badge--active {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-apikey-status-badge--expiring {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-apikey-status-badge--expired {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n/* ===== Expiry Section ===== */\n.admin-apikey-expiry-section {\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n\n.admin-apikey-expiry-header {\n  padding: 12px 16px;\n  background: var(--admin-surface-hover);\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-apikey-expiry-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-apikey-expiry-body {\n  padding: 16px;\n}\n\n.admin-apikey-expiry-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.admin-apikey-expiry-remaining {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  white-space: nowrap;\n}\n\n/* ===== Verify Box ===== */\n.admin-apikey-verify-box {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: var(--admin-radius-md, 8px);\n  margin-top: 12px;\n}\n\n.admin-apikey-verify-box--pending {\n  background: rgba(96, 165, 250, 0.08);\n  border: 1px solid rgba(96, 165, 250, 0.2);\n}\n\n.admin-apikey-verify-box--success {\n  background: var(--admin-success-bg);\n  border: 1px solid rgba(74, 222, 128, 0.2);\n}\n\n.admin-apikey-verify-box--error {\n  background: var(--admin-error-bg);\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.admin-apikey-verify-box__icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.admin-apikey-verify-box__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-apikey-verify-box__desc {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n  margin-top: 2px;\n}\n\n/* ===== Key Change Section ===== */\n.admin-apikey-change-section {\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  overflow: hidden;\n}\n\n.admin-apikey-change-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: var(--admin-surface-hover);\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.admin-apikey-change-header:hover {\n  background: var(--admin-border);\n}\n\n.admin-apikey-change-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-apikey-change-chevron {\n  color: var(--admin-text-muted);\n  transition: transform 0.2s;\n}\n\n.admin-apikey-change-chevron--open {\n  transform: rotate(180deg);\n}\n\n.admin-apikey-change-body {\n  padding: 16px;\n  border-top: 1px solid var(--admin-border);\n}\n\n/* ===== History List ===== */\n.admin-apikey-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.admin-apikey-history-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--admin-border-light);\n  position: relative;\n}\n\n.admin-apikey-history-item:last-child {\n  border-bottom: none;\n}\n\n.admin-apikey-history-item__icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.admin-apikey-history-item__icon--change {\n  background: rgba(96, 165, 250, 0.12);\n}\n\n.admin-apikey-history-item__icon--verify {\n  background: var(--admin-success-bg);\n}\n\n.admin-apikey-history-item__icon--expire {\n  background: rgba(251, 191, 36, 0.12);\n}\n\n.admin-apikey-history-item__icon--create {\n  background: rgba(167, 139, 250, 0.12);\n}\n\n.admin-apikey-history-item__icon--delete {\n  background: var(--admin-error-bg);\n}\n\n.admin-apikey-history-item__content {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-apikey-history-item__title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-primary);\n  margin-bottom: 2px;\n}\n\n.admin-apikey-history-item__title strong {\n  font-weight: 600;\n}\n\n.admin-apikey-history-item__detail {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-family: monospace;\n}\n\n.admin-apikey-history-item__time {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ===== Context Window Column ===== */\n.admin-model-item__context {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  min-width: 56px;\n}\n\n.admin-model-item__context-label {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-model-item__context-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  font-family: monospace;\n}\n\n/* ===== Capability Badge (short label variant) ===== */\n.admin-llm__cap-badge {\n  min-width: 22px;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n/* ===== Connection Test Result Modal ===== */\n.admin-llm__test-result {\n  border-radius: var(--admin-radius-md, 8px);\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.admin-llm__test-result--success {\n  background: var(--admin-success-bg);\n  border: 1px solid rgba(74, 222, 128, 0.2);\n}\n\n.admin-llm__test-result--error {\n  background: var(--admin-error-bg);\n  border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.admin-llm__test-result-status {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n  margin-bottom: 12px;\n}\n\n.admin-llm__test-result--success .admin-llm__test-result-status {\n  color: var(--admin-success);\n}\n\n.admin-llm__test-result--error .admin-llm__test-result-status {\n  color: var(--admin-error);\n}\n\n.admin-llm__test-result-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.admin-llm__test-result-row:last-child {\n  margin-bottom: 0;\n}\n\n.admin-llm__test-result-key {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.admin-llm__test-result-val {\n  font-size: 12px;\n  color: var(--admin-text-primary);\n}\n\n.admin-llm__test-result-val--mono {\n  font-family: monospace;\n  background: var(--admin-surface-hover);\n  padding: 1px 6px;\n  border-radius: var(--admin-radius-sm, 4px);\n}\n\n.admin-llm__test-result-val--error {\n  color: var(--admin-error);\n  word-break: break-all;\n}\n\n/* ===== Sample Response Block ===== */\n.admin-llm__test-sample {\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md, 8px);\n  overflow: hidden;\n}\n\n.admin-llm__test-sample-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  padding: 8px 12px;\n  background: var(--admin-surface-hover);\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-llm__test-sample-body {\n  margin: 0;\n  padding: 12px;\n  font-size: 12px;\n  font-family: monospace;\n  color: var(--admin-text-secondary);\n  background: var(--admin-bg);\n  white-space: pre-wrap;\n  word-break: break-all;\n  max-height: 200px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
